import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL, EMAIL, EMAIL_MAILTO } from "@/lib/contact";
import { track } from "@/lib/track";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0d2731] text-[#f6f3ec]">
      <div className="container-avelis py-14 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <Link to="/" aria-label="AVELIS — Retour à l'accueil" className="inline-flex items-center rounded-xl bg-[#f6f3ec] px-5 py-4">
              <img src="/avelis-logo-full.png" alt="AVELIS by DK Soins SRL — Tarification infirmière" className="h-9 w-auto" />
            </Link>
            <p className="mt-6 text-lg font-bold tracking-tight text-[#b5c4b1]">Vous soignez. Nous tarifons.</p>
            <p className="mt-3 text-sm text-[#f6f3ec]/65 leading-relaxed max-w-sm">
              Tarification infirmière pour les professionnels de santé en Belgique. Wallonie et Bruxelles francophone.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#b5c4b1]">Contact</p>
            <ul className="mt-5 space-y-3.5 text-sm">
              <li>
                <a
                  href={PHONE_TEL}
                  data-testid="footer-phone"
                  onClick={() => track("click_phone_footer")}
                  className="inline-flex items-center gap-2.5 text-[#f6f3ec]/85 hover:text-[#b5c4b1] transition-colors"
                >
                  <Phone className="h-4 w-4 text-[#b5c4b1]" strokeWidth={2} />
                  Téléphone : {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  onClick={() => track("click_whatsapp_footer")}
                  className="inline-flex items-center gap-2.5 text-[#f6f3ec]/85 hover:text-[#b5c4b1] transition-colors"
                >
                  <WhatsAppIcon className="h-4 w-4 text-[#b5c4b1]" />
                  WhatsApp : {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  href={EMAIL_MAILTO}
                  data-testid="footer-email"
                  onClick={() => track("click_email")}
                  className="inline-flex items-center gap-2.5 text-[#f6f3ec]/85 hover:text-[#b5c4b1] transition-colors"
                >
                  <span className="dot-sage" aria-hidden="true" />
                  E-mail : {EMAIL}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#b5c4b1]">Liens</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link data-testid="footer-link-conseils" className="text-[#f6f3ec]/75 hover:text-[#b5c4b1] transition-colors" to="/conseils">Conseils</Link></li>
              <li><Link data-testid="footer-link-mentions" className="text-[#f6f3ec]/75 hover:text-[#b5c4b1] transition-colors" to="/mentions-legales">Mentions légales</Link></li>
              <li><Link data-testid="footer-link-confidentialite" className="text-[#f6f3ec]/75 hover:text-[#b5c4b1] transition-colors" to="/confidentialite">Politique de confidentialité</Link></li>
              <li><Link data-testid="footer-link-cookies" className="text-[#f6f3ec]/75 hover:text-[#b5c4b1] transition-colors" to="/cookies">Gestion des cookies</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-7 border-t border-[#f6f3ec]/12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-[#f6f3ec]/45">© {new Date().getFullYear()} DK Soins SRL. Tous droits réservés.</p>
          <p className="text-xs text-[#f6f3ec]/45 flex items-center gap-2">
            <span className="dot-sage" aria-hidden="true" />
            Veiller. Simplifier. Avancer.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
